<div class="m-t-1"
     [ngClass]="fontClass"
     [innerHTML]="message | translate"></div>
